import { AcctutorialResultCustomHead } from '@components/common/customHead';
import Layout from '@components/common/layout';
import Content from '@components/common/content';
import SampleResult from '@components/acca/sampleResult';

const SampleResultPage = () => {
  return (
    <Layout>
      <AcctutorialResultCustomHead />
      <Content>
        <SampleResult />
      </Content>
    </Layout>
  );
};

export default SampleResultPage;
